import Grid from '@mui/material/Grid2';
import { Control, UseFormWatch } from 'react-hook-form';
import { EEmployeeContract } from '../../../../../shared/enums/user/EContract';
import { IFormField } from '../../../../../shared/interfaces/forms/IForms';
import { IUser } from '../../../../../shared/interfaces/user/IUser';
import FormField from '../FormField';

interface IProps {
  control: Control<IUser>;
  watch: UseFormWatch<IUser>;
  formFields: IFormField[];
}

const ProfessionalInformation = ({ control, formFields, watch }: IProps) => {
  return (
    <Grid container spacing={2}>
      {formFields?.filter((field) => {
        if (field.key === "contractEndDate") {
          return watch('employeeContract') === EEmployeeContract.FIXED_TERM
        }
        return true;
      })?.map((userKey) => (
        <FormField userKey={userKey} control={control} key={userKey.key} />
      ))}
    </Grid>
  );
};

export default ProfessionalInformation;
